var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"tile bg-white p-0 block w-full",on:{"click":_vm.routeToDetails}},[_c('div',{staticClass:"tile is-vertical p-4 text-center max-w-full"},[(_vm.imgPath)?_c('div',{staticClass:"mx-auto flex items-center justify-center mb-4 w-full",class:{
                'mb-2': Boolean(_vm.name),
                'h-32': !_vm.isLarge,
                'lg:w-32': !_vm.isLarge,
                'h-40': _vm.isLarge,
                'lg:w-40': _vm.isLarge
            }},[_c('img',{staticClass:"max-h-full block",attrs:{"src":_vm.imgPath}})]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }